import styled from 'styled-components'
import { COLORS } from 'theme'

export const StyledP = styled.p`
  margin-bottom: 0;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: ${COLORS.GREY_T_20};
  ${props => props.textType && `text-transform: ${props.textType};`}
  span {
    text-transform: capitalize;
  }
`
export const ErrorText = styled.p`
  margin-bottom: 0;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: ${COLORS.ERROR};
`
export const Wrapper = styled.div`
  overflow-y: auto;
  margin-left: -1.5rem;
  margin-top: 0.5rem;
`
